module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Auswahl Adressen",
      "autocomplete": "",
      "loading": _vm.loading,
      "dark": "",
      "multiple": "",
      "cache-items": "",
      "chips": "",
      "required": "",
      "items": _vm.adressen,
      "item-text": "strasse",
      "item-value": "id",
      "return-object": "",
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.fa.adressen),
      callback: function($$v) {
        _vm.$set(_vm.fa, "adressen", $$v)
      },
      expression: "fa.adressen"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fa.adressen), function(adresse, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs6": ""
      }
    }, [_c('p', [_c('strong', [_vm._v(" " + _vm._s(adresse.strasse) + " ")]), _c('br'), _vm._v("\n                    " + _vm._s(adresse.plz) + " " + _vm._s(adresse.ort) + " \n                ")])])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af2f39e0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/adressenSelect.vue
// module id = 341
// module chunks = 0